import React, { useState, useEffect } from 'react';
import { UserService } from '../../services/UserService';
import { FolderService } from '../../services/FolderService';
import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import { GlobalContext } from "../../services/GlobalProvider";
import { useNavigate } from "react-router";
import { Navbar, Container, Nav, NavDropdown, Dropdown, Button, Row, Col } from 'react-bootstrap';
import './Dossiers.scss';



const Dossiers = () => {


  const { setFolderDetails, folders } = React.useContext(GlobalContext);

  const [dossiers, setDossiers] = useState(null)

  const navigate = useNavigate();

  /*   useEffect(() => {
      if(folders && folders.length == 1){
        setFolderDetails(folders[0])
        navigate(`/${folders[0]?.dossier?._id}/accueil`)
      }else{
        setDossiers(folders)
      }
    }, [folders]); */

  return (
    <Container fluid id="Dossiers" className="py-4">
      <Row className="mt-5">
        {(folders?.length > 0) &&
          <>
            <Col xs="12" md="5" lg="4" xl="3" xxl="2" className="offset-lg-1 text-end">
              <h6 className="mb-2 text-primary">Choisir un dossier</h6>
              <h3 className="fw-bold">Sur quel dossier<br></br>souhaitez vous travailler ?</h3>
            </Col>

            <Col xs="12" md="7" lg="5" xl="4" xxl="3" className="ms-lg-4">
              {folders.map((dossier, i) => (
                <a href={`/${dossier?.dossier?._id}/accueil`} className="card w-100 d-flex flex-row align-items-center col-2 mb-2 py-3 px-4 bg-white text-dark hover-bg-primary-500 rounded cursor-pointer" key={dossier?.dossier?._id} /* onClick={() => navigate(`/${dossier._id}/accueil`)} */>
                  <i className="material-icons-outlined me-2 ">folder</i>
                  <h6 className="m-0">{dossier?.dossier?.nom}</h6>
                </a>
              ))
              }
            </Col>
          </>
        }
        {!folders &&
          <Col className="ms-lg-4">
            <em>- Aucun dossier trouvé -</em>
          </Col>
        }
      </Row>
    </Container>
  );
}

export default Dossiers;
